import { useEffect, useState, Dispatch } from "react";
import { getCurrentUser, Person } from "../api/person";
import { invalidateSignOn } from "../api/sign-in";
import { useHistory } from "react-router";

let userDispatch: Dispatch<Person | null> = () => void 0;

export function useCurrentUser(): Person | null {
  const [user, setUser] = useState<Person | null>(null);
  userDispatch = setUser;

  useEffect(() => {
    getCurrentUser().then(setUser);
  }, []);

  return user;
}

export function useSignOut(): VoidFunction {
  const { push } = useHistory();

  return () => {
    userDispatch(null);
    invalidateSignOn()
      .then(() => push("/sign-in"))
      .catch(() => push("/sign-in"));
  };
}
